module.exports = __webpack_public_path__ + "static/media/siemens-energy_logo.e452eeef.png";